<script lang="ts" setup>
import { Studio } from '@/modules/Studios/types'
import { getCurrentInstance } from 'vue'
import { useImage } from '@/shared/composables/image'

const { getAvatar } = useImage()
defineProps<{
  studio: Studio | undefined
}>()

const instance = getCurrentInstance()
</script>

<template>
  <div
    v-if="studio"
    class="tab-content"
  >
    <div class="description-section">
      <span class="about-title">Description</span>
      <div v-if="studio.description">
        <!-- eslint-disable-next-line -->
        <p v-html="instance?.proxy?.$sanitize(studio.description)" />
      </div>
    </div>

    <div class="stats-section">
      <div class="owners">
        <span
          v-if="studio.admins.length"
          class="about-title"
        >
          Studio owners
        </span>
        <router-link
          v-for="admin in studio.admins"
          :key="admin.id"
          :to="{ name: 'Profile', params: { id: admin.id } }"
          class="owner-chip"
        >
          <v-avatar size="32">
            <v-img :src="getAvatar(admin.avatar, 64)" />
          </v-avatar>
          <span class="name">{{ admin.dancerName }}</span>
        </router-link>
      </div>

      <div
        v-if="studio.founded"
        class="date-created"
      >
        <span class="about-title">Date created</span>
        {{ studio.founded }}
      </div>
    </div>
  </div>
  <div
    v-else
    class="placeholder"
  >
    No information found for this studio
  </div>
</template>

<style lang="scss" scoped>
@import '@/assets/style/mixins';

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
  font-weight: var(--font-weight-bold);
  font-size: 18px;
}

.tab-content {
  display: flex;
  justify-content: space-between;

  @media (max-width: $screen-sm) {
    flex-direction: column-reverse;
  }

  .description-section {
    width: 100%;
    max-width: 575px;
    color: var(--color-black);

    @media (max-width: $screen-sm) {
      margin-bottom: 20px;
    }
  }

  .about-title {
    display: block;
    margin-bottom: 12px;
    font-weight: var(--font-weight-bold);

    @media (max-width: $screen-sm) {
      margin-bottom: 6px;
    }
  }

  .stats-section {
    min-width: 220px;

    .owners {
      margin-bottom: 40px;

      @media (max-width: $screen-sm) {
        margin-bottom: 20px;
      }
    }

    .owner-chip {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      color: inherit;
      cursor: pointer;

      .name {
        margin-left: 8px;
      }
    }

    .date-created {
      margin-bottom: 18px;
    }
  }
}
</style>

<style lang="scss">
.about .text {
  ul,
  li {
    list-style-type: inherit;
  }

  p {
    margin: 0;
  }
}
</style>
